import React from "react";
import { Loader2 } from "lucide-react";

export const AdminButton = ({ children, variant = "primary", className = "", loading, ...props }) => {
    const variants = {
        primary: "bg-garden-green hover:bg-garden-green-dark text-white",
        secondary: "bg-cream-dark hover:bg-cream-dark/80 text-deep-green",
        danger: "bg-red-100 hover:bg-red-200 text-red-700",
        ghost: "hover:bg-cream-dark text-deep-green",
    };
    return (
        <button
            {...props}
            disabled={loading || props.disabled}
            className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl font-medium text-sm transition disabled:opacity-50 ${variants[variant]} ${className}`}
        >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            {children}
        </button>
    );
};

export const AdminInput = ({ label, className = "", ...props }) => (
    <div>
        {label && <label className="block text-sm font-medium text-deep-green mb-1.5">{label}</label>}
        <input
            {...props}
            className={`w-full px-4 py-2.5 rounded-xl border border-cream-dark bg-white focus:outline-none focus:ring-2 focus:ring-garden-green/30 text-deep-green text-sm ${className}`}
        />
    </div>
);

export const AdminTextarea = ({ label, className = "", ...props }) => (
    <div>
        {label && <label className="block text-sm font-medium text-deep-green mb-1.5">{label}</label>}
        <textarea
            {...props}
            className={`w-full px-4 py-2.5 rounded-xl border border-cream-dark bg-white focus:outline-none focus:ring-2 focus:ring-garden-green/30 text-deep-green text-sm ${className}`}
        />
    </div>
);

export const AdminCard = ({ children, className = "", ...rest }) => (
    <div {...rest} className={`bg-white rounded-2xl border border-cream-dark p-6 shadow-sm ${className}`}>
        {children}
    </div>
);
